import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import SvelteMarkdown from "../../node_modules/@humanspeak/svelte-markdown/dist/index.js";
import { AlertRenderer, KatexRenderer, markedAlert, markedKatex } from "../../node_modules/@humanspeak/svelte-markdown/dist/extensions/index.js";
import { normalizeHeadingAnchors } from "./headings.js";
import SlexCode from "./SlexCode.svelte";

var root = $.from_html(`<div class="slex-doc-streamdown"><!></div>`);

export default function MarkdownRenderer($$anchor, $$props) {
	$.push($$props, true);

	let slexkitRenderMode = $.prop($$props, 'slexkitRenderMode', 3, "component"),
		slexkitRuntime = $.prop($$props, 'slexkitRuntime', 3, "trusted"),
		slexkitUseGlobalRuntimeHost = $.prop($$props, 'slexkitUseGlobalRuntimeHost', 3, false),
		slexkitSecurePolicy = $.prop($$props, 'slexkitSecurePolicy', 19, () => ({})),
		slexkitSecureFrame = $.prop($$props, 'slexkitSecureFrame', 3, true),
		slexkitStreaming = $.prop($$props, 'slexkitStreaming', 3, false),
		slexkitIncomplete = $.prop($$props, 'slexkitIncomplete', 3, false);

	const extensions = [markedKatex({ singleDollarInline: true }), markedAlert()];

	const renderers = {
		alert: AlertRenderer,
		inlineKatex: KatexRenderer,
		blockKatex: KatexRenderer
	};

	const options = { headerIds: false };
	var div = root();
	var node = $.child(div);

	{
		const code = ($$anchor, $$arg0) => {
			let lang = () => ($$arg0?.()).lang;
			let text = () => ($$arg0?.()).text;

			SlexCode($$anchor, {
				get lang() {
					return lang();
				},

				get text() {
					return text();
				},

				get domain() {
					return $$props.domain;
				},

				get renderMode() {
					return slexkitRenderMode();
				},

				get runtime() {
					return slexkitRuntime();
				},

				get runtimeHost() {
					return $$props.slexkitRuntimeHost;
				},

				get useGlobalRuntimeHost() {
					return slexkitUseGlobalRuntimeHost();
				},

				get securePolicy() {
					return slexkitSecurePolicy();
				},

				get hostAdapter() {
					return $$props.slexkitHostAdapter;
				},

				get secureFrame() {
					return slexkitSecureFrame();
				},

				get streaming() {
					return slexkitStreaming();
				},

				get incomplete() {
					return slexkitIncomplete();
				},
				className: 'slex-doc-slexkit-demo'
			});
		};

		let $0 = $.derived(() => normalizeHeadingAnchors($$props.content));

		SvelteMarkdown(node, {
			get source() {
				return $.get($0);
			},

			get extensions() {
				return extensions;
			},

			get renderers() {
				return renderers;
			},

			get options() {
				return options;
			},
			code,
			$$slots: { code: true }
		});
	}

	$.reset(div);
	$.append($$anchor, div);
	$.pop();
}